import Alert from './src/main';
require('library-@/assets/styles/ui-default-theme/alert.scss');

/* istanbul ignore next */
Alert.install = function(Vue) {
    Vue.component(Alert.name, Alert);
};

export default Alert;
